module.exports = __webpack_public_path__ + "static/media/learning-10.51b17c9a.png";